import script from "./addUser.vue?vue&type=script&setup=true&lang=js"
export * from "./addUser.vue?vue&type=script&setup=true&lang=js"

import "./addUser.vue?vue&type=style&index=0&id=2bc1f542&lang=css"

const __exports__ = script;

export default __exports__